import { render } from "./AppControls.vue?vue&type=template&id=ff5e826e&scoped=true"
import script from "./AppControls.vue?vue&type=script&lang=js"
export * from "./AppControls.vue?vue&type=script&lang=js"

import "./AppControls.vue?vue&type=style&index=0&id=ff5e826e&scoped=true&lang=css"

import exportComponent from "/home/cherry/safer_pet/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5e826e"]])

export default __exports__